/**
 * gs-card-add — ajout au panier depuis les cartes produit (pages collection, etc.)
 * SANS quitter la page : ouvre le tiroir latéral au lieu de naviguer vers /cart.
 *
 * Les cartes (snippet gs-card-extras) utilisent un <form method="post" action="/cart/add">
 * classique → par défaut le navigateur soumet et redirige vers la page panier.
 * Ici on intercepte ce submit, on ajoute en AJAX (/cart/add.js) en demandant le rendu
 * de la section du tiroir, puis on redispatche l'événement 'cart:update' du thème.
 * Conséquences (machinerie native Horizon) :
 *   - <cart-drawer-component> écoute 'cart:update' et s'ouvre (attribut auto-open) ;
 *   - <cart-items-component> du tiroir se re-morphe avec la section renvoyée ;
 *   - l'icône panier de l'en-tête met à jour son compteur.
 * Même pattern éprouvé que gs-cart-suggest.js (bouton « + » des suggestions du tiroir).
 *
 * Repli sans JS : si ce script ne tourne pas, le <form> POST natif fonctionne toujours
 * (il redirige simplement vers /cart, l'ancien comportement).
 */
(function () {
  if (window.__gsCardAddInit) return;
  window.__gsCardAddInit = true;

  // Ids des sections panier à re-rendre (le tiroir contient un <cart-items-component>).
  function cartSectionIds() {
    var ids = [];
    document.querySelectorAll('cart-items-component').forEach(function (c) {
      if (c.dataset && c.dataset.sectionId && ids.indexOf(c.dataset.sectionId) === -1) {
        ids.push(c.dataset.sectionId);
      }
    });
    return ids.join(',');
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (!form.matches('.gsc-buy, .gsc-add')) return;
    event.preventDefault();

    var idInput = form.querySelector('[name="id"]');
    var variantId = idInput && idInput.value;
    if (!variantId) return;

    var qtyInput = form.querySelector('[name="quantity"]');
    var quantity = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;

    var btn = form.querySelector('[type="submit"]');
    if (btn) {
      btn.disabled = true;
      btn.style.opacity = '0.55';
    }

    var body = { id: variantId, quantity: quantity };
    var sections = cartSectionIds();
    if (sections) {
      body.sections = sections;
      body.sections_url = window.location.pathname;
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    })
      .then(function (r) {
        return r.json().then(function (data) { return { ok: r.ok, data: data }; });
      })
      .then(function (res) {
        if (!res.ok) {
          // Erreur (ex. stock insuffisant) : on n'ouvre pas le tiroir, on réactive le bouton.
          console.warn('[gs-card-add]', (res.data && (res.data.description || res.data.message)) || 'add failed');
          return;
        }
        document.dispatchEvent(
          new CustomEvent('cart:update', {
            bubbles: true,
            detail: { data: { sections: res.data.sections, source: 'gs-card-add' } },
          })
        );
      })
      .catch(function (err) { console.error('[gs-card-add]', err); })
      .finally(function () {
        if (btn) {
          btn.disabled = false;
          btn.style.opacity = '';
        }
      });
  });
})();
